import React from 'react';
import './AboutUs.css';
import { useTranslation } from 'react-i18next';

const AboutUs: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="about-us">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 >{t('aboutUs.title')}</h2>
            <p>{t('aboutUs.para1')}</p>
            <p>{t('aboutUs.para2')}</p>
          </div>
          <div className="about-video">
            <iframe
              src="https://www.youtube.com/embed/udTI8uWmABo"
              title="Yata Medical Presentation"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="video-frame"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
